import React from 'react';
import { Select, SelectChangeEvent, Box, Typography } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HeaderSelectMenuItem from 'features/header/components/header-select-menu-item';
import { trackEvent } from 'utils/amplitude.util';
import { AmplitudeEvents } from 'shared/enums/amplitude-events.enum';

type Props = {
  selectItems: string[];
  adminEmail?: string;
};

const HeaderSelectMenu: React.FC<Props> = (props) => {
  const [, setSelectedItem] = React.useState('');

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedItem(event.target.value);
  };

  const handleOpen = () => {
    trackEvent(AmplitudeEvents.PROFILE_MENU_OPENED, {
      user_email: props.adminEmail,
    });
  };

  const menuItems = props.selectItems;

  return (
    <Select
      size="small"
      id="select"
      label={props.adminEmail}
      value=""
      onChange={handleChange}
      onOpen={handleOpen}
      displayEmpty
      renderValue={() => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ color: 'white' }}>{props.adminEmail}</Typography>
          <AccountCircleIcon sx={{ color: 'white' }} />
        </Box>
      )}
      IconComponent={() => null}
      sx={{
        border: 'none',
        '.MuiOutlinedInput-notchedOutline': { border: 'none' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        backgroundColor: 'transparent',
        paddingX: 0,
      }}
    >
      {menuItems?.map((item) => (
        <HeaderSelectMenuItem key={item} selectMenuItem={item} />
      ))}
    </Select>
  );
};
export default HeaderSelectMenu;
